import { render } from "./AdminForumReview.vue?vue&type=template&id=277f22e5"
import script from "./AdminForumReview.vue?vue&type=script&lang=js"
export * from "./AdminForumReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__